import { render, staticRenderFns } from "./ReportMealsTabEmployees.vue?vue&type=template&id=62add4b2"
import script from "./ReportMealsTabEmployees.vue?vue&type=script&lang=js"
export * from "./ReportMealsTabEmployees.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports